(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element && event.target.closest('[data-nadine-share]');
    if (!(button instanceof HTMLElement)) return;

    const url = new URL(location.pathname, location.origin);
    const variant = new URLSearchParams(location.search).get('variant');
    if (variant) url.searchParams.set('variant', variant);

    const colour = document.querySelector('[data-track-colour]')?.getAttribute('data-track-colour') || undefined;
    const track = (method) => window.posthog?.capture?.('product_shared', { method, colour });

    if (navigator.share) {
      try {
        await navigator.share({ title: button.dataset.title, url: url.href });
        track('share');
      } catch (error) {
        // AbortError = the customer closed the share sheet.
      }
      return;
    }

    try {
      await navigator.clipboard.writeText(url.href);
    } catch (error) {
      return;
    }
    track('copy');
    const status = button.querySelector('.nadine-share__status');
    if (!status) return;
    status.textContent = button.dataset.copied || '';
    clearTimeout(Number(button.dataset.timer));
    button.dataset.timer = String(setTimeout(() => (status.textContent = ''), 2500));
  });
  } catch(e) { console.error(e); }
})();

})();
